// src/components/WeeklyNews.jsx
import React from "react";
import { CiCalendar, CiClock1 } from "react-icons/ci";
import { GoArrowRight } from "react-icons/go";
import { Link } from "react-router-dom";

/* ----------------------------------------------------
   Helper → pick EN or AR value safely
---------------------------------------------------- */
const pickLang = (value, lang) => {
  if (!value) return "";
  if (typeof value === "object") return value[lang] || value.en || "";
  return value;
};

const NewsCard = ({ item, isAdmin, onEdit, onDelete, language }) => {
  const title = pickLang(item.title, language);
  const desc = pickLang(item.desc, language);
  const category = pickLang(item.category, language);

  return (
    <div className="card mb-3">
      <div className="row g-0 align-items-stretch">

        {/* ---------- TEXT ---------- */}
        <div className="col-md-7">
          <div className="card-body">

            <div className="top-pagecate">{category}</div>

            <h5 className="card-title">{title}</h5>

            <div className="text-muted small mb-1 news-time">
              <CiCalendar /> {item.date}
              <span className="mx-3"></span>
              <CiClock1 /> {item.time}
            </div>

            <p className="text-muted">
              {desc?.length > 140 ? desc.slice(0, 140) + "..." : desc}
            </p>

            <Link to={`/news/${language}/${item.id}`}  className="news-read-btn">
              {language === "ar" ? "اقرأ المزيد" : "Read More"} <GoArrowRight />
            </Link>

            {/* ---------- ADMIN OPTIONS ---------- */}
            {isAdmin && (
              <div className="d-flex gap-2 mt-3">
                <button className="news-read-btn" onClick={() => onEdit(item)}>
                  {language === "ar" ? "تعديل" : "Edit"}
                </button>

                <button
                  className="news-read-btn"
                  onClick={() => onDelete(item.id, "news")}
                >
                  {language === "ar" ? "حذف" : "Delete"}
                </button>
              </div>
            )}

          </div>
        </div>

        {/* ---------- IMAGE ---------- */}
        <div className="col-md-5">
          <img
            src={item.img}
            alt={title}
            className="img-fluid h-100 w-100 rounded"
            style={{ objectFit: "cover" }}
            onError={(e) => {
              if (!e.target.dataset.fallback) {
                e.target.dataset.fallback = "true";
                e.target.src = "/images/fallback.png"; // optional
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

const WeeklyNews = ({ items, isAdmin, onEdit, onDelete, language = "en" }) => {
  if (!items || items.length === 0)
    return (
      <p>
        {language === "ar" ? "لا توجد أخبار أسبوعية" : "No weekly news available"}
      </p>
    );

  return (
    <>
      <h5 className="news-card-title">
        {language === "ar" ? "أفضل الأخبار الأسبوعية" : "Weekly Best News"}
      </h5>

      {items.map((item) => (
        <NewsCard
          key={item.id}
          item={item}
          isAdmin={isAdmin}
          onEdit={onEdit}
          onDelete={onDelete}
          language={language}
        />
      ))}
    </>
  );
};

export default WeeklyNews;
